import React from 'react'

interface GameLayoutProps {
  children: React.ReactNode
}

export function GameLayout({ children }: GameLayoutProps) {
  return (
    <div className="w-full">
      {children}
    </div>
  )
} 